import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { RequestEndorseSubject } from '../../../shared/request-endorse-subject.model';

@Component({
  selector: 'app-subject-endorse',
  templateUrl: './subject-endorse.component.html',
  styleUrls: ['./subject-endorse.component.scss']
})
export class SubjectEndorseComponent implements OnInit , OnChanges {

  displayedColumns: string[] = ['materia', 'maetriaHomologada'];
  dataSource: MatTableDataSource<RequestEndorseSubject>;
  @Input() subjects: RequestEndorseSubject[];

  constructor() { }

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.subjects);
  }
  ngOnChanges() {
    this.dataSource = new MatTableDataSource(this.subjects);
  }

}
